// extracted by mini-css-extract-plugin
export var standaloneTable = "_i7-0";
export var standaloneTableWithBodyFill = "_i7-1";
export var withExtraHeader = "_i7-2";